import { render, staticRenderFns } from "./CoordinateGrid.vue?vue&type=template&id=ffe54c22&"
import script from "./CoordinateGrid.vue?vue&type=script&lang=ts&"
export * from "./CoordinateGrid.vue?vue&type=script&lang=ts&"
import style0 from "./CoordinateGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports